var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRideDuration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3645 8.37209C0.876133 14.6977 5.46528 16.5891 7.9459 16.7442V18.6047C5.71334 18.6047 3.91489 17.6744 3.29473 17.2093C2.05442 16.4341 -0.333174 13.7674 0.0389194 9.30233C1.1552 4.46512 5.1552 2.94574 7.01566 2.7907V1.86047H5.1552V0H10.7366V1.86047H8.87613V2.7907C9.62032 2.7907 11.3567 3.41085 12.1319 3.72093L13.0622 2.7907L15.8529 5.5814L14.9226 6.51163C16.0389 8 16.0079 10.2326 15.8529 11.1628H13.9924C13.9924 9.67442 13.6823 8.68217 13.5273 8.37209C13.0622 7.13178 11.2947 4.65116 7.9459 4.65116C3.75985 4.65116 2.82962 7.44186 2.3645 8.37209Z",
    fill: "#12B76A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4722 13.6585L18.3108 16.5778C18.4479 16.6463 18.4479 16.842 18.3108 16.9106L12.4722 19.8299C12.3337 19.8991 12.1755 19.7792 12.2042 19.627C12.3671 18.7621 12.5971 17.3851 12.5971 16.7442C12.5971 16.1033 12.3671 14.7263 12.2042 13.8613C12.1755 13.7092 12.3337 13.5893 12.4722 13.6585Z",
    fill: "#12B76A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01567 11.6279V6.51163H8.87613V9.76744H12.1319V11.6279H7.01567Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRideDuration);
export default __webpack_public_path__ + "static/media/ride-duration.764e7691e027c01c0b43c67ee56645f4.svg";
export { ForwardRef as ReactComponent };